// extracted by mini-css-extract-plugin
export var alertIcon = "_sq-0";